import { render, staticRenderFns } from "./index.vue?vue&type=template&id=006d2d17&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=006d2d17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006d2d17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('006d2d17')) {
      api.createRecord('006d2d17', component.options)
    } else {
      api.reload('006d2d17', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=006d2d17&scoped=true&", function () {
      api.rerender('006d2d17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contentCenter/newMall/getGouponsStatistics/index.vue"
export default component.exports